import React from 'react';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const FulfillmentOrderItemsTooltip = ({ fulfillmentOrderItems, fulfillmentOrderId }) => {
	return (
		<React.Fragment>
			<ReactTooltip className="surcharge" id={`$surchargeTooltip-${fulfillmentOrderId}`}>
				<table>
					<colgroup>
						<col width="120"/>
						<col />
					</colgroup>
					<thead>
						<tr>
							<th className="type--left">SKU</th>
							<th className="type--right">Qty.</th>
						</tr>
					</thead>
					<tbody>
						{_.map(fulfillmentOrderItems, item => {
							return (
								<tr>
									<td className="type--left">{item.sku}</td>
									<td className="type--right">{item.quantity}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</ReactTooltip>
			<i
				data-for={`$surchargeTooltip-${fulfillmentOrderId}`}
				data-tip=""
				className="fa fa-info-circle spc--left--tny flex--grow--1"
			></i>
		</React.Fragment>
	);
};

export default defaultTemplate(FulfillmentOrderItemsTooltip);



// WEBPACK FOOTER //
// ./src/common/tooltips/FulfillmentOrderItemsTooltip.jsx